module.exports = __webpack_public_path__ + "img/footer.91887046.svg";